import React from 'react'
import { node, number } from 'prop-types'
import { Box } from '@mui/material'
const BasicTab = props => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{ mt: 2 }}>{children}</Box>
    </div>
  )
}
export default BasicTab
BasicTab.propTypes = {
  children: node,
  index: number.isRequired,
  value: number.isRequired
}
